import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import List from './components/List';

// Styled.
import * as S from './styled';

const Tile = ({
  className = '',
  icon = undefined,
  title = undefined,
  content = undefined,
  actions = undefined,
  list = undefined,
  description = undefined,
}) => (
  <S.Tile className={className}>
    {(title || icon || actions) && (
      <S.Header>
        {(title || icon) && (
          <S.Title>
            {icon && <FontAwesomeIcon icon={icon} />}
            {title && title}
          </S.Title>
        )}
        {actions && <S.Actions>{actions}</S.Actions>}
      </S.Header>
    )}
    <S.Content isList={list}>
      {description}
      {list && <List data={list} />}
      {content}
    </S.Content>
  </S.Tile>
);

Tile.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  actions: PropTypes.any,
  content: PropTypes.any,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
    }),
  ),
  description: PropTypes.node,
};

export default Tile;
